const toggleDialog = (state, { payload }) => {
    state.dialogs[payload.name] = { open: !state.dialogs[payload.name]?.open, data: payload.data };
};

export default toggleDialog;
